<template>
  <div id="app" class="app">
    <CurvedBar class="header-bar">
      <template v-slot:left-content>
        <div class="back-btn-wrapper">
          <BackButton class="header-back-link" />
        </div>
      </template>
      <template v-slot:center-content>
        <div class="logo-bubble">
          <a href="https://www.splitthebills.co.uk/" class="home-link">
            <Logo class="logo" />
          </a>
        </div>
      </template>
    </CurvedBar>

    <router-view />

    <trustpilot-widget />

    <FooterInfo />

    <CookieBanner />

    <LoadingPanel v-if="showLoadingPanel" />
  </div>
</template>

<script>
import CurvedBar from "@/components/CurvedBar";
import BackButton from "@/components/BackButton";
import LoadingPanel from "@/components/LoadingPanel";
import Logo from "@/assets/svg/logo.svg";
import TrustpilotWidget from "@/components/TrustpilotWidget";
import CookieBanner from "@/components/CookieBanner.vue";
import FooterInfo from "@/components/FooterInfo.vue";
import { mapActions } from "vuex";

export default {
  name: "AppRoot",
  computed: {
    showBackBtn() {
      return this.$store.state.uiState.showBackBtn;
    },
    showLoadingPanel() {
      return this.$store.state.uiState.isLoading;
    },
  },
  components: {
    FooterInfo,
    CookieBanner,
    TrustpilotWidget,
    BackButton,
    CurvedBar,
    Logo,
    LoadingPanel,
  },
  methods: {
    ...mapActions(["fetchFeatureFlags"]),
  },
  created() {
    this.fetchFeatureFlags();
  },
};
</script>

<style lang="scss">
.has-footer {
  .app {
    min-height: calc(100vh - 11rem - 15rem);

    @include media("<medium") {
      min-height: calc(100vh - 5.5rem - 9rem);
    }
  }
}

.app {
  //overflow-y: hidden;
  min-height: calc(100vh - 11rem);

  @include media("<medium") {
    min-height: calc(100vh - 5.5rem);
  }
}

.header-bar {
  @include media("<medium") {
    height: 50px !important;
  }
}

.back-btn-wrapper {
  flex: 1;

  .header-back-link {
    position: relative;
    top: 8px;
    left: 15px;

    background: $brand-green;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 0 1rem;

    font-weight: $font-regular;

    &:focus {
      outline: none;
    }

    @include media(">=medium") {
      display: none;
    }
  }
}

.logo-bubble {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 150px;
  height: 150px;
  margin-top: -50px;

  background: $brand-gradient-vertical;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  border-radius: 50%;

  @include media("<medium") {
    width: 90px;
    height: 90px;
    margin-top: -30px;
  }

  .home-link {
    color: $white;

    .logo {
      margin-top: 40px;
      width: 80px;
      height: 53px;

      @include media("<medium") {
        width: 60px;
        height: 40px;
        margin-top: 20px;
      }
    }
  }
}
</style>
